import { g as getIconConfiguration } from "../services/icon/utils/get-icon-configuration.js";
import { a as useGlobalConfig } from "../services/global-config/global-config.js";
const useIcon = () => {
  const { globalConfig } = useGlobalConfig();
  return {
    getIcon: (name) => getIconConfiguration(name, globalConfig.value.icons)
  };
};
export { useIcon as u };
//# sourceMappingURL=useIcon.js.map
